import { Auth0Provider, Auth0ProviderOptions, User } from '@auth0/auth0-react';
import ENV from '@/env/env';
import apiClient from '@/api';
import { AxiosError } from 'axios';

const USERS_BASE_API_URL = '/api/v1/user';

const saveUser = async (user: User) => {
	const firstName = user['yesenergy/user_metadata'].firstname;
	const lastName = user['yesenergy/user_metadata'].lastname;
	const payload = {
		auth0UserId: user.sub,
		email: user.email,
		userName: user.name,
		firstName: firstName || user.given_name || '',
		lastName: lastName || user.family_name || ''
	};

	try {
		await apiClient.post(USERS_BASE_API_URL, payload);
	} catch (err: unknown) {
		console.error(`Error ${(err as AxiosError).status}. Could not save user.`);
	}
};

function Auth0ProviderWithHistory({
	children,
	...rest
}: Omit<Auth0ProviderOptions, 'domain' | 'clientId' | 'authorizationParams'>) {
	return (
		<Auth0Provider
			domain={ENV.AUTH0_BASE_URL ?? ''}
			clientId={ENV.AUTH0_CLIENT_ID ?? ''}
			authorizationParams={{
				redirect_uri: window.location.origin,
				audience: 'https://lpoh_backend/',
				scope: 'openid offline_access profile email'
			}}
			onRedirectCallback={async (appState, user) => {
				if (user) {
					await saveUser(user);
				}

				if (appState?.returnTo) {
					window.history.pushState({}, document.title, appState.returnTo);
					window.dispatchEvent(new Event('popstate'));
				}
			}}
			{...rest}
		>
			{children}
		</Auth0Provider>
	);
}

export default Auth0ProviderWithHistory;
